module.exports = __webpack_public_path__ + "img/helicopter-grey.dc9a0c8c.svg";